import { render } from "./blog-content-detail.vue?vue&type=template&id=022bc76e"
import script from "./blog-content-detail.vue?vue&type=script&lang=js"
export * from "./blog-content-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__